var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((this.fields),function(field){return _c('div',{key:field.name},[_c('b',[_vm._v(_vm._s(field.displayName))]),(field.value)?_c('p',[_vm._v(_vm._s(field.value))]):_c('p',[_vm._v("-")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }